import { useEffect, useState } from "react";
import { useApiOperation } from "src/api/hooks";
import { getBuildingDeviceToRegister } from "src/api/iot/iot-api";
import { IoTDeviceRegistration, RegisteredDeviceQueryParams } from "src/api/iot/iot-types";
import { PageMeta } from "src/api/public-types";

export function useIotManagementList(query: RegisteredDeviceQueryParams) {
  const [list, setList] = useState<IoTDeviceRegistration[]>([]);
  const [pageMeta, setPageMeta] = useState<PageMeta>();

  const { executeAsync: getList } = useApiOperation(getBuildingDeviceToRegister);

  useEffect(() => {
    const fetchIotDeviceList = async (params: RegisteredDeviceQueryParams) => {
      const newParams = { ...params, searchType: undefined, searchKeyword: undefined };
      const { data } = await getList(newParams);
      setList(data.data.content || []);
      setPageMeta(data.meta?.pageMeta);
    };

    fetchIotDeviceList(query);
  }, [getList, query]);

  return { list, pageMeta };
}
